{
	"language": {
		"select": "Chọn ngôn ngữ",
		"sectionTitle": "Ngôn ngữ",
		"changeSuccess": "Đã đổi ngôn ngữ thành công"
	},
	"assistant": {
		"composer": {
			"placeholder": "Hỏi {{assistantName}}",
			"disclaimer": "{{assistantName}} có thể mắc lỗi. Hãy kiểm tra thông tin quan trọng."
		},
		"greeting": {
			"initialMessage": "👋 Xin chào, tôi là trợ lý học tập **{{assistantName}}**, và tôi ở đây để giúp bạn chuẩn bị tốt hơn cho **{{context}}!** Hãy cùng tìm hiểu kỹ câu hỏi bạn đã trả lời về **{{topic}}.**",
			"starter": "Xin chào, tôi là **{{assistantName}}**. Tôi có thể giúp gì cho bạn?"
		},
		"chips": {
			"askYourOwn": "Đặt câu hỏi của riêng bạn",
			"askFollowUp": "Đặt câu hỏi tiếp theo"
		},
		"emptyState": {
			"title": "{{assistantName}} là trợ lý học tập AI của bạn",
			"contextSubtitle": "Hỏi bất cứ điều gì về {{context}}",
			"activateSubtitle": "{{assistantName}} sẽ được kích hoạt sau khi bạn trả lời câu hỏi"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "Học nhanh",
			"examInfo": {
				"subtitle": {
					"setExamDate": "Đặt ngày thi để nhận được đề xuất phù hợp hơn.",
					"examDateWithValue": "Ngày thi: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "Có thể tốt hơn",
				"itsAwesome": "Rất tuyệt"
			},
			"title": "Bạn đang tiến bộ rất tốt!",
			"body": "Chúng tôi rất vui khi thấy bạn chăm chỉ học tập! Trải nghiệm của bạn với ứng dụng đến lúc này thế nào? Bạn có thể chia sẻ suy nghĩ của mình qua một bài đánh giá không?",
			"cta": "Có thể để sau"
		},
		"actions": {
			"studyWeak": "Tập trung vào phần còn yếu",
			"viewProgress": "Xem tiến độ của bạn",
			"seeRank": "Kiểm tra thứ hạng",
			"seeRankings": "Xem bảng xếp hạng",
			"unlock": "Mở khóa nội dung cao cấp",
			"unlockTooltip": "Truy cập các tính năng độc quyền và tài liệu học nâng cao bằng cách mở khóa nội dung cao cấp",
			"startCustomSession": "Tạo buổi học tùy chỉnh",
			"startCustomSessionTooltip": "Bắt đầu buổi học tùy chỉnh để tập trung vào những nội dung cụ thể",
			"takeDiagnostic": "Làm bài đánh giá đầu vào",
			"takeDiagnosticTooltip": "Làm bài đánh giá đầu vào để xác định trình độ hiện tại và điều chỉnh kế hoạch học phù hợp",
			"viewDiagnostic": "Xem kết quả đánh giá đầu vào",
			"viewDiagnosticTooltip": "Xem kết quả đánh giá đầu vào để biết điểm mạnh và những phần cần cải thiện",
			"viewPodcasts": "Nghe podcast",
			"viewPodcastsTooltip": "Truy cập các podcast giáo dục để nâng cao trải nghiệm học tập",
			"upgradeToPremium": "Nâng cấp lên Premium",
			"upgradeToPremiumTooltip": "Nâng cấp lên Premium để truy cập toàn bộ nội dung và tính năng",
			"extendAccess": "Gia hạn quyền truy cập",
			"extendAccessTooltip": "Gia hạn quyền truy cập vào nội dung và tính năng cao cấp",
			"setExamDate": "Đặt ngày thi",
			"setExamDateTooltip": "Đặt ngày thi để theo dõi tiến độ và chuẩn bị cho kỳ thi"
		},
		"exam": {
			"daysAgo_one": "{{count}} ngày trước",
			"daysAgo_other": "{{count}} ngày trước",
			"untilExam_one": "Còn {{count}} ngày đến kỳ thi",
			"untilExam_other": "Còn {{count}} ngày đến kỳ thi",
			"isToday": "Hôm nay là ngày thi!"
		},
		"stats": {
			"mastery": "Mức độ thành thạo",
			"completed_one": "Câu đã trả lời",
			"completed_other": "Câu đã trả lời",
			"completedValue": "{{count}}",
			"xpEarned": "XP đã nhận",
			"xpEarnedValue": "{{value}}",
			"accuracy": "Độ chính xác",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "Trình độ {{skill, lowercase}} ước tính của bạn là {{level, lowercase}}",
			"itemsAnsweredTooltip": "Tổng số câu bạn đã trả lời cho đến nay",
			"responsesAnsweredTooltip": "Tổng số câu trả lời bạn đã gửi cho đến nay",
			"examDateTooltip": "Kỳ thi của bạn vào {{date}}",
			"skillCta": {
				"diagnostic": "Đánh giá đầu vào",
				"practice": "Luyện tập"
			}
		},
		"menu": {
			"settings": "Cài đặt",
			"profile": "Hồ sơ"
		},
		"diagnostics": {
			"title": "Đánh giá đầu vào",
			"free": "Miễn phí",
			"duration": "{{count}} {{item}} • {{minutes}} phút",
			"completed": "Đã hoàn thành {{count}} {{item}}",
			"start": "Bắt đầu",
			"viewReport": "Xem báo cáo",
			"resume": "Tiếp tục"
		},
		"practiceTests": {
			"title": "Bài thi thử",
			"sectionalTestsTitle": "Bài thi theo phần",
			"diagnosticAssessmentsTitle": "Đánh giá đầu vào",
			"premiumChipTooltip": "Bài thi thử cao cấp, đầy đủ thời lượng cho kỳ thi {{examName}}",
			"freeChipTooltip": "{{label}} cho kỳ thi {{examName}}",
			"freeChipTooltipDefault": "Bài đánh giá đầu vào miễn phí cho kỳ thi {{examName}}",
			"completedDescription_one": "{{count}} câu • {{date}}",
			"completedDescription_other": "{{count}} câu • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} câu • còn {{timeRemaining}}",
			"activeDescription_other": "{{attempted}}/{{count}} câu • còn {{timeRemaining}}",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} câu • còn {{timeRemaining}} • Bắt đầu: {{startedOn}} • Kết thúc: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} câu • còn {{timeRemaining}} • Bắt đầu: {{startedOn}} • Kết thúc: {{endsOn}}",
			"notStartedDescription_one": "{{count}} câu • {{duration}}",
			"notStartedDescription_other": "{{count}} câu • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} câu • {{duration}} • Kết thúc: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} câu • {{duration}} • Kết thúc: {{endsOn}}",
			"viewResultsCta": "Xem kết quả",
			"startCta": "Bắt đầu",
			"chips": {
				"items_one": "{{count}} câu",
				"items_other": "{{count}} câu",
				"progress_one": "{{attempted}}/{{count}} câu",
				"progress_other": "{{attempted}}/{{count}} câu",
				"timeRemaining": "còn {{time}}",
				"startedOn": "Bắt đầu: {{date}}",
				"endsOn": "Kết thúc: {{date}}",
				"timeLeft": "còn {{time}}"
			},
			"status": {
				"notStarted": {
					"label": "Chưa bắt đầu",
					"section": "Bài thi thử đầy đủ"
				},
				"inProgress": {
					"label": "Đang làm",
					"section": "Đang làm"
				},
				"completed": {
					"label": "Đã hoàn thành",
					"section": "Đã hoàn thành"
				},
				"legacyReports": {
					"label": "Báo cáo cũ",
					"section": "Báo cáo cũ"
				},
				"migratedReports": {
					"label": "Báo cáo đã chuyển",
					"section": "Báo cáo đã chuyển"
				}
			}
		},
		"skills": {
			"title": "Kỹ năng",
			"unlockSubtitle": "Mở khóa premium để luyện tập",
			"startCta": "Luyện tập",
			"freeItemsIncludedChip": "Bao gồm mục miễn phí",
			"freeItemsAnsweredSubtitle_one": "{{answered, number}} trên {{count, number}} mục miễn phí đã trả lời",
			"freeItemsAnsweredSubtitle_other": "{{answered, number}} trên {{count, number}} mục miễn phí đã trả lời",
			"progressCards": {
				"questionTypesTitle": "Kết quả theo dạng câu hỏi",
				"questionTypesSubtitle": "Điểm số của bạn ở các dạng câu hỏi {{skill}}",
				"proficiencyTitle": "Kết quả theo trình độ",
				"proficiencySubtitle": "Tiến độ của bạn qua các cấp độ {{skill}}",
				"questionTypeCardSubtitle": "Tiến độ theo cấp độ thành thạo",
				"bySkillTitle": "Kết quả theo kỹ năng",
				"bySkillSubtitle": "Tiến độ tổng thể ở các kỹ năng",
				"needsImprovementTitle": "Cần cải thiện",
				"needsImprovementSubtitle": "Các kỹ năng nên tập trung tiếp theo",
				"skillPerformanceTitle": "Kết quả kỹ năng {{skill}}",
				"skillPerformanceSubtitle": "Tiến độ theo dạng câu hỏi và trình độ",
				"skillLevelSubtitle": "Tiến độ của bạn ở cấp độ kỹ năng này",
				"skillsPerformanceTitle": "Kết quả các kỹ năng",
				"performanceByItemDifficulty": "Kết quả theo mức độ thành thạo của câu hỏi",
				"performanceByItemDifficultyCaption_one": "Hiển thị độ chính xác của bạn theo cấp độ thành thạo, dựa trên {{count}} câu đã làm",
				"performanceByItemDifficultyCaption_other": "Hiển thị độ chính xác của bạn theo cấp độ thành thạo, dựa trên {{count}} câu đã làm",
				"questionTypePartSubtitle": "{{skill}} · Phần {{part}}",
				"activityGoalTitle": "Hoạt động & Tiến độ mục tiêu",
				"recentActivityTitle": "Hoạt động gần đây",
				"goalProgressTitle": "Tiến độ mục tiêu",
				"goalProgressSubtitle": "Điểm tổng thể · 7 tuần gần nhất",
				"goalProgressInsight": "Bạn đang tiến bộ đều đặn. Bạn còn cách mục tiêu 14 điểm và có thể đạt mục tiêu trong khoảng 3 tuần.",
				"goalProgressActualLabel": "Điểm của bạn",
				"goalProgressTargetLabel": "Mục tiêu",
				"goalProgressTimeAxisLabel": "Thời gian",
				"goalProgressScoreAxisLabel": "Tiến độ tổng thể",
				"statusTitle": "Trạng thái của bạn",
				"diagnosticsTitle": "Đánh giá đầu vào",
				"diagnosticsReviewCta": "Xem lại",
				"strengthsFocusTitle": "Điểm mạnh & Nội dung cần tập trung",
				"strengthsFocusSubtitle": "Những nội dung bạn làm tốt nhất và các dạng câu hỏi cần luyện tập thêm",
				"strengthsLabel": "Điểm mạnh",
				"focusAreasLabel": "Nội dung cần tập trung",
				"recommendedNextStepLabel": "Bước tiếp theo được đề xuất",
				"recommendedNextStepCta": "Bắt đầu",
				"practiceTestsViewMore": "Xem tất cả {{count}} bài thi"
			},
			"proficiencySection": "Luyện tập theo cấp độ thành thạo"
		},
		"recommendedTasks": {
			"sectionTitle": "Đề xuất cho bạn",
			"startSessionAction": "Luyện tập",
			"resumeAction": "Tiếp tục",
			"reviewResultsAction": "Xem lại kết quả",
			"startTestAction": "Bắt đầu bài thi",
			"activeTestBody": "Hoàn thành bài đánh giá đang làm",
			"completedTestBody": "Xem lại kết quả và câu trả lời của bạn",
			"diagnosticBody": "Làm {{label}} để làm quen với cấu trúc kỳ thi",
			"diagnosticDefaultLabel": "bài đánh giá đầu vào miễn phí",
			"practiceTestBody": "Đánh giá mức độ sẵn sàng cho kỳ thi bằng bài thi có giới hạn thời gian.",
			"sectionalTestBody": "Làm bài thi tập trung để luyện kỹ năng {{skills}}.",
			"weakSkillTitle": "Củng cố {{skill}} của bạn",
			"weakSkillBody": "Luyện {{questionType}}, ưu tiên những phần bạn chưa nắm vững.",
			"strongSkillTitle": "Giữ vững {{skill}}",
			"strongSkillBody": "Bạn đang vững ở đây. Một bộ {{questionType}} ngắn giúp duy trì.",
			"mixedSkillTitle": "Bổ sung {{skill}} của bạn",
			"mixedSkillBody": "Bộ hỗn hợp các dạng {{questionTypes}}, ưu tiên những phần bạn còn thiếu.",
			"higherDifficultySkillTitle": "Nâng lên {{proficiency}}",
			"higherDifficultySkillBody": "Bạn đã nắm {{questionType}} ở mức này. Những câu này khó hơn một bậc.",
			"itemsChip_one": "{{count}} câu",
			"itemsChip_other": "{{count}} câu",
			"timeRemainingChip": "Còn {{minutes}} phút",
			"timeRemainingChipCompact": "{{minutes}} phút"
		},
		"itemTypes": {
			"answeredLabel_one": "Câu đã trả lời",
			"answeredLabel_other": "Câu đã trả lời",
			"answeredAll": "Tất cả",
			"answeredPartial": "{{answered}} trên {{total}}",
			"cardSubtitleResponses_one": "{{count}} câu trả lời",
			"cardSubtitleResponses_other": "{{count}} câu trả lời",
			"responsesLabel_one": "Câu trả lời",
			"responsesLabel_other": "Câu trả lời",
			"cardSubtitleComplete": "Đã trả lời tất cả các câu",
			"cardSubtitlePartial": "Đã trả lời {{attempted}} trên {{total}} câu",
			"detail": {
				"skillLabel": "Kỹ năng",
				"estimatedLevelLabel": "Trình độ ước tính"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} câu trả lời",
			"responseCount_other": "{{count, number}} câu trả lời"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "Bao gồm {{count, number}} mục luyện tập miễn phí",
			"freeContentBannerTitle_other": "Bao gồm {{count, number}} mục luyện tập miễn phí",
			"freeContentBannerBody": "Luyện tập các mục {{skills}} bất cứ lúc nào. Nâng cấp để mở khóa toàn bộ Study-Pack.",
			"freeContentBannerCta": "Bắt đầu luyện tập miễn phí",
			"freeSampleBanner": {
				"body_one": "Luyện tập các mục được chọn từ {{categories}} bất cứ lúc nào. Nâng cấp để mở khóa thêm {{count, number}} mục.",
				"body_other": "Luyện tập các mục được chọn từ {{categories}} bất cứ lúc nào. Nâng cấp để mở khóa thêm {{count, number}} mục.",
				"moreTags": "thêm {{count, number}} {{label}}",
				"cta": "Nâng cấp"
			}
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "Xem thứ hạng của bạn so với những người khác"
		},
		"home": {
			"title": "Trang chủ"
		},
		"podcasts": {
			"description": "Nghe podcast về chỉnh hình do chuyên gia hướng dẫn."
		},
		"more": {
			"title": "Cài đặt khác"
		}
	},
	"emptyState": {
		"progress": {
			"title": "Chưa có tiến độ học tập",
			"subtitle": "Tiến độ của bạn sẽ xuất hiện tại đây khi bạn học",
			"cta": "Học ngay"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "Lỗi",
			"body": "Không thể tạo buổi học, vui lòng thử lại"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "Nâng cao",
			"highIntermediate": "Trung cấp",
			"intermediate": "Trung cấp",
			"basic": "Cơ bản",
			"none": "Chưa trả lời",
			"high": "Đã thành thạo",
			"medium": "Sắp thành thạo",
			"low": "Cần cải thiện"
		}
	},
	"leaderboard": {
		"you": "Đây là bạn",
		"periods": {
			"all_time": "Toàn thời gian",
			"month": "Tháng này",
			"week": "Tuần này"
		},
		"scope": {
			"global": "Toàn cầu",
			"friends": "Bạn bè"
		},
		"friends": {
			"soon": "SẮP RA MẮT",
			"comingSoonTitle": "Bảng xếp hạng bạn bè",
			"comingSoonBadge": "Sắp ra mắt",
			"comingSoonDescription": "So sánh tiến độ với bạn bè và xem ai đang đứng đầu lớp."
		},
		"error": {
			"title": "Lỗi kết nối",
			"description": "Không thể tải bảng xếp hạng. Hãy kiểm tra kết nối và thử lại.",
			"tryAgain": "Thử lại"
		},
		"empty": {
			"title": "Chưa có thứ hạng",
			"description": "Hãy là người đầu tiên bắt đầu học và giành vị trí dẫn đầu bảng xếp hạng.",
			"startLearning": "Bắt đầu học"
		},
		"topPerformers": "Người học xuất sắc",
		"yourPosition": "Vị trí của bạn",
		"rankings": "Bảng xếp hạng",
		"rankingsRange": "Thứ hạng • #{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "Kiếm XP để tham gia bảng xếp hạng!",
			"description": "Bắt đầu một buổi học để kiếm điểm đầu tiên và tham gia bảng xếp hạng.",
			"cta": "Bắt đầu buổi học đầu tiên"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "BẠN",
		"podium": {
			"first": "Hạng 1",
			"second": "Hạng 2",
			"third": "Hạng 3"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>để vượt qua #{{rank}}</rest>",
			"gapHintFromPodium": "<num>+{{value}}</num><unit> XP</unit> <rest>để lên bục xếp hạng</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "Bài học",
			"statusFilter": {
				"all": "Tất cả",
				"inProgress": "Đang học",
				"notStarted": "Chưa bắt đầu",
				"completed": "Đã hoàn thành"
			},
			"card": {
				"openCta": "Mở",
				"resumeCta": "Tiếp tục",
				"viewResultsCta": "Xem kết quả",
				"duration_one": "{{count}} phút",
				"duration_other": "{{count}} phút"
			},
			"viewToggle": {
				"list": "Chế độ danh sách",
				"grid": "Chế độ lưới"
			},
			"empty": {
				"filteredTitle": "Không có bài học nào khớp với bộ lọc này",
				"filteredSubtitle": "Hãy thử bộ lọc trạng thái khác",
				"filteredCta": "Hiện tất cả",
				"noneTitle": "Không tìm thấy bài học",
				"noneSubtitle": "Thử bỏ bộ lọc hoặc bắt đầu tìm kiếm mới",
				"noneCta": "Đặt lại tất cả"
			}
		},
		"home": {
			"hero": {
				"greeting": "Chào mừng {{name}}!",
				"greetingNoName": "Chào mừng bạn!"
			},
			"stats": {
				"modulesDone": "Mô-đun đã hoàn thành",
				"dayStreak": "Chuỗi ngày",
				"minutesToday": "Phút hôm nay"
			},
			"suggested": {
				"title": "Gợi ý cho bạn",
				"openModuleCta": "Mở mô-đun",
				"status": {
					"ready": "Sẵn sàng",
					"next": "Tiếp theo"
				}
			},
			"all": {
				"title": "Tất cả bài học"
			},
			"emptyState": {
				"title": "Chưa có bài học nào",
				"subtitle": "Hãy quay lại sau để xem bài học mới."
			},
			"card": {
				"duration_one": "{{count}} phút",
				"duration_other": "{{count}} phút"
			}
		},
		"overview": {
			"header": {
				"title": "Tổng quan"
			},
			"startCta": "Bắt đầu học",
			"objectives": {
				"title": "Mục tiêu học tập"
			}
		},
		"detail": {
			"takeQuizCta": "Làm bài kiểm tra",
			"progress": {
				"label": "Tiến độ học phần"
			},
			"activities": {
				"title": "Hoạt động",
				"completedCount": "Đã hoàn thành {{completed}} trên {{total}}"
			},
			"artifact": {
				"startCta": "Start",
				"resumeCta": "Resume",
				"reviewCta": "Review",
				"listenAgainCta": "Listen again",
				"readAgainCta": "Read again"
			},
			"tabs": {
				"content": "Content",
				"insights": "Insights",
				"cme": "CME"
			}
		},
		"stats": {
			"insights": {
				"title": "Thông tin tiến độ"
			},
			"milestones": {
				"title": "Cột mốc học phần",
				"startCta": "Start"
			}
		},
		"studyGuide": {
			"progress": {
				"label": "Đã đọc"
			},
			"readTime": "Đọc trong {{count}} phút",
			"sectionBadge": {
				"label": "Phần {{number}} trên {{total}}"
			},
			"upNext": {
				"title": "Tiếp theo"
			}
		},
		"cme": {
			"notStarted": {
				"title": "Start earning CME for this module",
				"description": "You haven't started this module yet. Complete the required activities to begin earning credit toward your certificate.",
				"cta": "Start learning"
			},
			"inProgress": {
				"title": "CME in progress",
				"description": "Complete all required activities to earn your CME credits and generate your certificate",
				"cta": "Continue learning"
			},
			"incompleteFootnote": "Certificates are only available after all CME requirements have been fulfilled. Partial completion does not qualify for credit.",
			"ready": {
				"completedOn": "Completed {{date}}",
				"title": "Certificate ready, {{credits}} credits earned",
				"description": "You've completed all required activities for this module.",
				"creditTableCaption": "What earned this credit",
				"downloadCta": "Download PDF",
				"redownloadCta": "Re-download PDF",
				"emailCta": "Email me",
				"downloadNotice": "You already downloaded a certificate for this module on {{date}}.",
				"downloadNoticeLink": "See that certificate",
				"footnote": "This credit will also be added to your total CME balance."
			}
		}
	},
	"sessionConfig": {
		"title": "Buổi học tùy chỉnh",
		"diagnostic": "Đánh giá đầu vào",
		"skill": "Kỹ năng",
		"Proficiency": "Trình độ",
		"Question Type": "Dạng câu hỏi",
		"mastery": "Mức độ thành thạo",
		"sessionLength": "Độ dài phiên",
		"itemsChip_one": "{{count}} mục",
		"itemsChip_other": "{{count}} mục",
		"durationEstimate": "{{minutes}} phút",
		"durationRange": "{{min}}–{{max}} phút",
		"noItemsTooltip": "Không có câu hỏi nào phù hợp với bộ lọc hiện tại",
		"setCount": "{{count}} {{type}}",
		"dismiss": "Đồng ý",
		"status": {
			"notAnswered": "Chưa trả lời",
			"needsWork": "Cần cải thiện"
		},
		"itemCount": "Bạn sẽ hoàn thành {{count}} câu thuộc {{topics}}",
		"start": "Bắt đầu buổi học",
		"configuringSession": "Đang thiết lập buổi học",
		"fetchingContent": "Đang tải nội dung",
		"preparingMaterials": "Đang chuẩn bị tài liệu",
		"almostThere": "Sắp xong",
		"startingSession": "Đang bắt đầu buổi học",
		"playIcon": "play-outline",
		"infoText": "Bạn sẽ hoàn thành **{{numItems}}** {{itemCount}}. Quá trình này sẽ mất khoảng **{{timeString}}**.",
		"customSummary": {
			"message": "Học $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) thuộc {{topics}}.",
			"messageWithMastery": "Học $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) thuộc {{topics}}, tập trung vào $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}) {{masteryLevels}}.",
			"messageAllMasteryLevels": "Học $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) thuộc {{topics}} ở tất cả các mức độ thành thạo.",
			"itemCount_one": "{{count}} câu",
			"itemCount_other": "{{count}} câu",
			"masteryLevelCount_one": "mức độ thành thạo",
			"masteryLevelCount_other": "các mức độ thành thạo",
			"allTopics": "tất cả {{count}} chủ đề",
			"more": "thêm {{count}} chủ đề",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "Học nhanh",
			"recommended": "Đề xuất",
			"custom": "Tùy chỉnh",
			"selectHelper": "Nhấn vào một buổi học để chọn, sau đó bắt đầu khi bạn đã sẵn sàng.",
			"emptyRecommended": "Hiện không có buổi học nào được đề xuất.",
			"summary": "Học {{count}} câu thuộc kỹ năng {{skill}}. Thời gian dự kiến: {{minutes}} phút.",
			"summary_questionType": "Học {{count}} câu thuộc kỹ năng {{skill}}, dạng {{questionType}}. Thời gian dự kiến: {{minutes}} phút.",
			"duration": "{{minutes}} phút",
			"durationSelector": {
				"title": "Thời lượng"
			},
			"levelSessions": {
				"rapidRecall": "Ôn nhanh",
				"purposefulPractice": "Luyện tập có mục tiêu",
				"focusFlow": "Tập trung chuyên sâu",
				"itemsLabel": "Câu hỏi {{level}}",
				"itemsLabelGeneric": "câu hỏi",
				"summaries": {
					"rapidRecall": "Làm quen nhanh với {{count}} câu {{level}} mà bạn chưa trả lời để từng bước mở rộng phạm vi kiến thức. Thời gian dự kiến: {{minutes}} phút.",
					"purposefulPractice": "Luyện tập với bộ {{count}} câu {{level}} cân bằng, bắt đầu từ nội dung cần cải thiện nhất. Thời gian dự kiến: {{minutes}} phút.",
					"focusFlow": "Củng cố những phần còn yếu với {{count}} câu {{level}} mà bạn đã trả lời ở mức thành thạo thấp hoặc trung bình. Thời gian dự kiến: {{minutes}} phút."
				},
				"summariesGeneric": {
					"rapidRecall": "Làm quen nhanh với {{count}} câu mà bạn chưa trả lời để từng bước mở rộng phạm vi kiến thức. Thời gian dự kiến: {{minutes}} phút.",
					"purposefulPractice": "Luyện tập với bộ {{count}} câu cân bằng, bắt đầu từ nội dung cần cải thiện nhất. Thời gian dự kiến: {{minutes}} phút.",
					"focusFlow": "Củng cố những phần còn yếu với {{count}} câu mà bạn đã trả lời ở mức thành thạo thấp hoặc trung bình. Thời gian dự kiến: {{minutes}} phút."
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "Để cá nhân hóa trải nghiệm của bạn, hãy bắt đầu bằng một bài kiểm tra chẩn đoán. Kết quả chẩn đoán của bạn sẽ được dùng để xây dựng kế hoạch học của bạn."
	},
	"premium": {
		"chip": "Cao cấp",
		"upgrade": "Nâng cấp lên gói cao cấp",
		"unlockTitle": "Mở khóa toàn bộ trải nghiệm {{productName}}",
		"unlockDescription": "Mở khóa luyện tập cá nhân hóa được thiết kế theo thời gian ôn tập còn lại của bạn.",
		"readyTitle": "Sẵn sàng cho kỳ thi ngày {{date}} của bạn",
		"tip": "Trọng tâm cá nhân hóa của bạn: Premium xác định nội dung cần luyện tập tiếp theo và điều chỉnh kế hoạch học tập khi bạn tiến bộ."
	},
	"purchase": {
		"success": {
			"headerTitle": "Cảm ơn bạn đã mua hàng!",
			"accessGranted": "Quyền truy cập vào {{name}} của bạn đã được cấp thành công",
			"studyPack": "Study-Pack",
			"practiceTest": "Bài thi thử",
			"combo": "Combo",
			"documentTitle": "Mua hàng",
			"summary_one": "Chúc mừng! **Sản phẩm** bên dưới đã được mở khóa trong tài khoản của bạn. Sau khi nhấn {{action}}, nội dung ứng dụng sẽ thay đổi theo kỳ thi: **{{examName}}**. Bạn có thể thay đổi bất cứ lúc nào trong cài đặt tài khoản nếu muốn học cho kỳ thi khác hoặc mua gói đăng ký khác.",
			"summary_other": "Chúc mừng! **{{count}} sản phẩm** bên dưới đã được mở khóa trong tài khoản của bạn. Sau khi nhấn {{action}}, nội dung ứng dụng sẽ thay đổi theo kỳ thi: **{{examName}}**. Bạn có thể thay đổi bất cứ lúc nào trong cài đặt tài khoản nếu muốn học cho kỳ thi khác hoặc mua gói đăng ký khác.",
			"unlockedDuration": "Chúc mừng! Bạn đã mở khóa **{{duration}}** quyền truy cập vào **{{name}}**. Quyền này sẽ hết hạn vào **{{expiry}}**.",
			"storeNote": "Lưu ý: Study-Pack chỉ có thể truy cập qua ứng dụng di động của chúng tôi. Vui lòng tải ứng dụng phù hợp với thiết bị của bạn.",
			"actions": {
				"goToHome": "Về trang chủ",
				"startDiagnostic": "Bắt đầu {{label}}",
				"takeDiagnostic": "Làm {{label}}",
				"takeFreeDiagnostic": "Làm bài kiểm tra đánh giá miễn phí",
				"diagnosticLabel": "bài kiểm tra đánh giá"
			}
		},
		"checkout": {
			"headerTitle": "Hoàn tất giao dịch mua"
		},
		"paywall": {
			"studyPackDialogTitle": "Nâng cấp kế hoạch học tập của bạn",
			"defaultDialogTitle": "Nâng cấp kế hoạch học tập của bạn",
			"practiceTestDialogTitle": "Mở khóa các bài thi thử",
			"restorePurchaseDialogTitle": "Bạn đã mua rồi?",
			"restorePurchaseDialogSubheadingWeb": "Nếu không, hãy thử cách này:",
			"restorePurchaseDialogBody": "Nếu bạn đã mua sản phẩm này nhưng nó vẫn bị khóa, hãy thử các cách sau:\n\n1. Đảm bảo bạn đã đăng nhập đúng tài khoản\n2. Đảm bảo bạn đã chọn đúng sản phẩm\n3. Đảm bảo gói đăng ký của bạn chưa hết hạn\n4. Đảm bảo bạn đã kích hoạt gói đăng ký (kiểm tra cả thư rác)\n5. Nếu bạn có mã truy cập, [mã truy cập]({{baseUrl}}/redeem)\n\nNếu không trường hợp nào phù hợp, vui lòng **nhấp vào đây**",
			"restorePurchaseDialogBodyWeb": "1. Đảm bảo bạn đã đăng nhập đúng email\n2. Đảm bảo **[kỳ thi đã chọn](/account/settings)** là đúng\n3. Đảm bảo gói đăng ký của bạn chưa hết hạn\n\nNếu không trường hợp nào phù hợp, vui lòng **liên hệ hỗ trợ**",
			"accesDuration": {
				"yearPlan": "Gói **{{duration}}** cung cấp thời gian truy cập dài hơn, giúp bạn linh hoạt tối đa để học theo tốc độ của riêng mình và chuẩn bị kỹ lưỡng cho kỳ thi.",
				"moreTime": "Nếu cho rằng mình sẽ cần thêm thời gian học, bạn có thể cân nhắc gói **{{duration}}**.",
				"otherPlan": "Gói **{{duration}}** sẽ cho phép bạn truy cập đến **{{expiryText}}**, nhờ đó bạn có đủ thời gian để học. {{moreTime}}"
			},
			"actions": {
				"upgrade": "Nâng cấp",
				"unlock": "Mở khóa với giá {{price}}",
				"subscribe": "Đăng ký với giá {{price}}",
				"extendAccess": "Gia hạn quyền truy cập",
				"accessHere": "Truy cập tại đây",
				"redeemAccessCode": "Bạn có mã truy cập?",
				"restorePurchase": "Bạn đã mua rồi?",
				"restorePurchaseWeb": "Bạn đã mua rồi hoặc có mã truy cập?"
			},
			"subscriptionSummary": {
				"yearly": "Gói đăng ký hằng năm • Tự động gia hạn • Hủy bất cứ lúc nào",
				"monthly": "Gói đăng ký hằng tháng • Tự động gia hạn • Hủy bất cứ lúc nào",
				"weekly": "Gói đăng ký hằng tuần • Tự động gia hạn • Hủy bất cứ lúc nào",
				"generic": "Gói đăng ký tự động gia hạn • Hủy bất cứ lúc nào"
			},
			"planDuration": {
				"day_one": "{{count}} ngày",
				"day_other": "{{count}} ngày",
				"week_one": "{{count}} tuần",
				"week_other": "{{count}} tuần",
				"month_one": "{{count}} tháng",
				"month_other": "{{count}} tháng",
				"year_one": "{{count}} năm",
				"year_other": "{{count}} năm"
			},
			"recommendedPlan": {
				"plan": "Chúng tôi khuyến nghị gói **{{duration}}** để bạn chuẩn bị tốt nhất cho kỳ thi vào **{{date}}**",
				"subscription": {
					"yearly": "Chúng tôi khuyến nghị **gói đăng ký hằng năm** để bạn truy cập liên tục và chuẩn bị cho kỳ thi vào **{{date}}**",
					"monthly": "Chúng tôi khuyến nghị **gói đăng ký hằng tháng** để bạn truy cập liên tục và chuẩn bị cho kỳ thi vào **{{date}}**",
					"weekly": "Chúng tôi khuyến nghị **gói đăng ký hằng tuần** để bạn truy cập liên tục và chuẩn bị cho kỳ thi vào **{{date}}**",
					"generic": "Chúng tôi khuyến nghị **gói đăng ký** để bạn truy cập liên tục và chuẩn bị cho kỳ thi vào **{{date}}**"
				}
			},
			"disclaimer": "Khi bạn xác nhận mua, bạn sẽ được toàn quyền truy cập nội dung của sản phẩm này trong thời hạn đã chọn. Khi thời hạn kết thúc, bạn sẽ mất quyền truy cập vào nội dung giới hạn. Nếu muốn gia hạn quyền truy cập vì bất kỳ lý do nào (ví dụ bạn đã dời ngày thi), bạn có thể mua thêm thời gian qua các giao dịch trong ứng dụng. Để biết thêm thông tin, hãy xem [Điều khoản dịch vụ và Chính sách quyền riêng tư](https://memorang.com/legal) của chúng tôi."
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "Dựa trên {{numItems}} {{item}} đã làm trong {{count}} {{type}}",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "Thông tin này cho biết tiến độ của bạn trong {{count}} {{type}}. Kết quả dựa trên {{itemCount}} {{item}} bạn đã làm cho đến nay."
		},
		"needsImprovement": {
			"title": "Cần cải thiện",
			"subtitle": "{{type}} được đề xuất để bạn cải thiện",
			"cta": "Học ngay"
		},
		"mastery": {
			"high": "Đã thành thạo",
			"medium": "Gần đạt",
			"low": "Cần luyện thêm",
			"count": "Đã làm {{count}} {{item}}",
			"zeroTooltip": "Chưa có mục {{label}} nào trong tổng số {{total}} mục đã làm",
			"highTooltip": "Bạn đã thành thạo {{count}} trong tổng số {{total}} {{item}} đã làm",
			"mediumTooltip": "Bạn đang tiến bộ ở {{count}} trong tổng số {{total}} {{item}} đã làm",
			"lowTooltip": "Bạn cần luyện tập thêm {{count}} trong tổng số {{total}} {{item}} đã làm"
		},
		"stats": {
			"completion": "Mức độ hoàn thành",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "Bạn đã hoàn thành {{completed}} trong tổng số {{total}} {{item}}"
		},
		"exams": {
			"title": "Bài thi thử",
			"subtitle_one": "Dựa trên {{count}} bài đánh giá đã hoàn thành",
			"subtitle_other": "Dựa trên {{count}} bài đánh giá đã hoàn thành"
		},
		"summary": {
			"title": "Tóm tắt quá trình học",
			"subtitle": "Dựa trên {{count}} {{item}} đã làm",
			"tooltip": "Bản tóm tắt này cho biết mức độ thành thạo và tiến độ hoàn thành của bạn trên tổng số {{count}} {{item}}. Kết quả của bạn được đánh giá qua các buổi luyện tập, bài đánh giá và hoạt động học tập.",
			"mastery": "Mức độ thành thạo",
			"quickStats": "Thống kê nhanh"
		},
		"languageLearning": {
			"proficiencyCardTitle": "Trình độ {{skill}}",
			"proficiencyCardTooltip": "Bạn hiện đang ở trình độ {{skill, lowercase}} {{level, lowercase}}",
			"itemTypesCardSubtitle_one": "{{count}} dạng mục",
			"itemTypesCardSubtitle_other": "{{count}} dạng mục",
			"itemTypesCardTitle": "Các mục {{skill}}",
			"itemTypeLevelTooltip": "Bạn hiện đang ở trình độ {{skill, lowercase}} {{level, lowercase}} ở dạng câu hỏi “{{itemType}}”",
			"itemTypesFallbackTitle": "Loại mục",
			"itemTypesEmptyTitle": "Không có loại mục",
			"itemTypesEmptySubtitle": "Không tìm thấy loại mục cho kỹ năng này. Hãy quay lại Tiến độ và thử lại.",
			"itemTypesEmptyCta": "Quay lại Tiến độ",
			"notAnswered": "Chưa trả lời",
			"answeredSubtitle_one": "Dựa trên {{count}} mục đã trả lời",
			"answeredSubtitle_other": "Dựa trên {{count}} mục đã trả lời",
			"responsesSubtitle_one": "Dựa trên {{count}} câu trả lời",
			"responsesSubtitle_other": "Dựa trên {{count}} câu trả lời",
			"testsTakenSubtitle_one": "Dựa trên {{count}} bài kiểm tra đã làm",
			"testsTakenSubtitle_other": "Dựa trên {{count}} bài kiểm tra đã làm",
			"startFirstTest": {
				"title": "Bắt đầu nào",
				"itemsSubtitle_one": "{{count}} câu",
				"itemsSubtitle_other": "{{count}} câu",
				"guidance": {
					"diagnostic": "Hãy bắt đầu bằng bài kiểm tra chẩn đoán để biết thế mạnh và điều chỉnh kế hoạch học.",
					"sectional": "Bài kiểm tra theo phần chỉ tập trung vào một phần của kỳ thi, nên bạn có điểm trong một buổi làm bài ngắn hơn.",
					"fullMock": "Bài thi thử đầy đủ mô phỏng kỳ thi thật từ đầu đến cuối và cho điểm đầy đủ nhất."
				}
			},
			"noScoresTitle": "Chưa có điểm {{skill, lowercase}}",
			"noScoresSubtitle": "Làm bài kiểm tra đầu tiên để xem điểm ước tính và bảng phân tích nhiệm vụ của bạn.",
			"noScoresCta": "Bắt đầu",
			"noScoresCardSubtitle": "Dựa trên các bài kiểm tra bạn làm",
			"personalBestLabel": "Thành tích cá nhân tốt nhất của bạn",
			"latestLabel": "Kết quả gần nhất của bạn",
			"examCountdown_one": "Còn {{count}} ngày nữa là đến kỳ thi",
			"examCountdown_other": "Còn {{count}} ngày nữa là đến kỳ thi",
			"greeting": {
				"none": "Hãy bắt đầu nhé, {{firstName}}! 🚀",
				"low": "Khởi đầu tốt lắm, {{firstName}} — tiếp tục phát huy nhé! 💪",
				"medium": "Tiếp tục phát huy nhé, {{firstName}}! 💪",
				"high": "Bạn sắp đạt mục tiêu rồi, {{firstName}}! 🎯"
			},
			"greetingNoName": {
				"none": "Hãy bắt đầu nhé! 🚀",
				"low": "Khởi đầu tốt lắm — tiếp tục phát huy nhé! 💪",
				"medium": "Tiếp tục phát huy nhé! 💪",
				"high": "Bạn sắp đạt mục tiêu rồi! 🎯"
			},
			"stats": {
				"untilExam": "Ngày thi",
				"itemsAnswered": "Mục đã trả lời",
				"responsesAnswered": "Câu trả lời"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "Mã truy cập không đúng",
		"incorrectPassword": "Mật khẩu không đúng. Vui lòng thử lại.",
		"passwordPlaceholder": "Nhập mật khẩu",
		"emailPlaceholder": "ví dụ: dave@gmail.com",
		"verify": {
			"openEmail": "Mở email để tiếp tục",
			"signInCta": "Đang xác minh tài khoản của bạn...",
			"signUpCta": "Đang tạo tài khoản của bạn...",
			"contactSupport": "Không thấy email? Hãy kiểm tra thư mục spam hoặc",
			"contactSupportLink": "Liên hệ với chúng tôi",
			"resendMagicLink": "Gửi lại magic link",
			"resendMagicLinkIn": "Gửi lại magic link sau {{time}}",
			"signInBody": "Sắp xong rồi! Chúng tôi đang xác minh thông tin của bạn để đăng nhập an toàn vào ứng dụng {{appName}}.",
			"signUpBody": "Sắp hoàn tất! Chúng tôi đang xác minh thông tin của bạn để tạo tài khoản ứng dụng {{appName}} mới.",
			"magicLinkEmail": "Chúng tôi đã gửi một magic link đến **{{email}}**\nNhấp vào liên kết trong email để đăng nhập an toàn.",
			"magicLinkEmailExpiry": "Liên kết này sẽ hết hạn sau 10 phút",
			"confirmEmail": "Xác nhận email của bạn",
			"redirectingToApp": "Đang chuyển hướng đến ứng dụng {{appName}}...",
			"appNotOpen": "Ứng dụng không mở? Hãy nhấp vào nút bên dưới để mở ứng dụng liên kết",
			"openApp": "Mở ứng dụng {{appName}}",
			"installAppPrompt": "Nếu không có gì xảy ra, hãy đảm bảo ứng dụng {{appName}} đã được cài đặt trên thiết bị của bạn",
			"verifyAccountTitle": "Xác minh tài khoản của bạn",
			"emailResent": "Đã gửi magic link đến {{email}}\nVui lòng kiểm tra hộp thư đến, bao gồm cả thư mục spam.",
			"verificationLinkExpired": "Liên kết xác minh đã hết hạn",
			"verificationLinkExpiredBody": "Liên kết xác minh sẽ hết hạn sau 10 phút và chỉ có thể được sử dụng một lần. \nBạn có thể yêu cầu liên kết mới bằng cách đăng nhập lại",
			"accountSetupTimeoutTitle": "Không thể hoàn tất đăng nhập",
			"accountSetupTimeoutBody": "Việc thiết lập tài khoản của bạn mất nhiều thời gian hơn dự kiến. Vui lòng thử đăng nhập lại hoặc liên hệ bộ phận hỗ trợ nếu tình trạng này tiếp diễn.",
			"loginAgain": "Đăng nhập lại",
			"contactSupportExpiredLink": "Nếu sự cố này vẫn tiếp diễn, hãy cho chúng tôi biết",
			"successTitle": "Bạn đã đăng nhập ở tab khác",
			"successBody": "Đóng tab này hoặc tiếp tục tại đây",
			"successCtaLabel": "Tiếp tục tại đây",
			"needHelpLabel": "Cần trợ giúp?",
			"contactSupportButton": "Liên hệ với chúng tôi"
		},
		"contactSupportDialog": {
			"title": "Bạn gặp sự cố khi đăng nhập?",
			"body": "Vui lòng liên hệ bộ phận hỗ trợ khách hàng nếu bạn gặp sự cố khi đăng nhập hoặc thử lại",
			"cta": "Gửi email cho chúng tôi"
		},
		"emailInstruction": {
			"default": "Nếu bạn không nhận được email, hãy kiểm tra thư mục thư rác, spam và các mục đã xóa gần đây",
			"edu": "Nếu bạn không nhận được email, hãy kiểm tra thư mục thư rác, spam và các mục đã xóa gần đây hoặc liên hệ quản trị viên CNTT"
		},
		"createSessionLoader": {
			"configuringSession": "Đang thiết lập buổi học",
			"analyzingMastery": "Đang phân tích mức độ thành thạo",
			"loadingContent": "Đang tải nội dung"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "Chúng tôi nên gọi bạn là gì?",
				"description": "Tên người dùng của bạn sẽ xuất hiện trên bảng xếp hạng công khai, còn tên thật của bạn vẫn được giữ riêng tư.",
				"usernameLabel": "Tên người dùng",
				"firstNameLabel": "Tên",
				"lastNameLabel": "Họ",
				"avatarLabel": "Ảnh đại diện",
				"avatarTooltip": "Ảnh đại diện được tự động tạo dựa trên tên người dùng của bạn.",
				"profileSaveFailed": "Không thể lưu hồ sơ của bạn. Vui lòng thử lại."
			},
			"testDate": {
				"cta": "Tiếp tục"
			},
			"examDate": {
				"daysAway": "Như vậy, chúng ta có {{value}} ngày. Chúng tôi sẽ ưu tiên ngay những phần bạn còn yếu nhất."
			},
			"skills": {
				"chooseAll": "Chọn tất cả các mục phù hợp"
			},
			"plan": {
				"recommended": "Được đề xuất"
			},
			"toeicLevelOverview": {
				"title": "Ai cũng bắt đầu từ một điểm nào đó.",
				"description": "Luyện tập giúp bạn thành thạo một cấp độ trước khi tiến lên cấp độ tiếp theo một cách tự nhiên.",
				"illustrationLabel": "Tiến trình từ Cơ bản (A1–A2) đến Trung cấp (B1–B2) rồi Thành thạo (C1).",
				"levels": {
					"basic": {
						"name": "Cơ bản",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "Trung cấp",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "Thành thạo",
						"band": "C1"
					}
				},
				"progression": {
					"title": "Bạn sẽ tiến bộ như thế nào",
					"practiceSessions": "Luyện tập các phiên được đề xuất",
					"buildMastery": "Xây dựng sự thành thạo ở cấp độ hiện tại",
					"growToward": "Tiếp tục phát triển hướng tới Thành thạo"
				},
				"levelDetails": {
					"title": "Ý nghĩa của từng cấp độ",
					"scoreRange": "{{band}} · điểm {{min}}–{{max}}",
					"basic": {
						"name": "Người dùng cơ bản",
						"summary": "Tiếng Anh đơn giản nơi công sở",
						"examples": {
							"forms": "Biểu mẫu & thông báo",
							"instructions": "Hướng dẫn",
							"announcements": "Thông báo ngắn"
						}
					},
					"intermediate": {
						"name": "Người dùng trung cấp",
						"summary": "Giao tiếp hằng ngày nơi công sở",
						"examples": {
							"emails": "Email & hội thoại",
							"customers": "Tương tác với khách hàng",
							"followUps": "Theo dõi sau cuộc họp"
						}
					},
					"proficient": {
						"name": "Người dùng thành thạo",
						"summary": "Tiếng Anh chuyên nghiệp & nâng cao",
						"examples": {
							"reports": "Báo cáo & thuyết trình phức tạp",
							"negotiations": "Đàm phán tinh tế",
							"highStakes": "Bối cảnh chuyên môn quan trọng"
						}
					}
				},
				"disclaimer": "Điểm TOEIC Link là hướng dẫn tham chiếu theo CEFR, không phải điểm chuẩn tuyệt đối. Reading và Listening tiến bộ độc lập — bạn có thể đạt cấp độ khác nhau ở mỗi kỹ năng."
			},
			"review": {
				"diagnosticChoice": {
					"title": "Đánh giá đầu vào: {{title}}",
					"body": "{{count}} câu hỏi để tìm ra điểm cần tập trung",
					"duration": "{{minutes}} phút"
				},
				"homeChoice": {
					"title": "Tự khám phá",
					"body": "Chưa sẵn sàng bắt đầu, tôi sẽ khám phá ứng dụng trước"
				}
			}
		},
		"common": {
			"changeLater": "Bạn có thể thay đổi mục này sau"
		},
		"actions": {
			"previous": "Trước",
			"finish": "Hoàn tất",
			"start": "Bắt đầu",
			"continue": "Tiếp tục",
			"stepIndicator": "Bước {{step}} trên {{total}}"
		}
	},
	"more": {
		"profile": {
			"title": "Về bạn"
		},
		"exam": {
			"title": "Kỳ thi của bạn"
		},
		"subscriptions": {
			"title": "Sản phẩm",
			"redeem": {
				"title": "Đổi mã mua hàng"
			},
			"extend": {
				"cta": "Gia hạn"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "Đặt ngày thi mục tiêu",
			"description": "Ngày này chỉ dùng để định hướng lịch học của bạn trong ứng dụng. Ngày này không ảnh hưởng đến việc đăng ký dự thi chính thức của bạn.",
			"dismissCta": "Để sau",
			"confirmCta": "Đặt ngày thi"
		}
	},
	"account": {
		"title": "Cài đặt tài khoản",
		"currentExam": "Bài thi hiện tại",
		"subscriptions": "Quyền lợi",
		"examDate": "Ngày thi",
		"examDateUpdated": "Đã đặt ngày thi là {{date}}",
		"selectDate": "Chọn ngày",
		"appearance": "Giao diện",
		"features": "Tính năng",
		"audioPlaybackTest": "Hiển thị hộp thoại kiểm tra phát âm thanh",
		"theme": "Chủ đề",
		"selectTheme": "Chọn chủ đề",
		"themeOptions": {
			"system": "Hệ thống",
			"light": "Sáng",
			"dark": "Tối"
		},
		"accountInfo": "Tài khoản",
		"username": "Tên người dùng",
		"name": "Tên",
		"nameNotSet": "Chưa thiết lập",
		"save": "Lưu",
		"editUsername": {
			"title": "Chỉnh sửa tên người dùng"
		},
		"editName": {
			"title": "Chỉnh sửa tên"
		},
		"email": "Email",
		"dev": "Dev",
		"sandbox": "Sandbox",
		"redoOnboarding": "Thiết lập lại từ đầu",
		"about": "Giới thiệu",
		"termsOfService": "Điều khoản dịch vụ",
		"privacyPolicy": "Chính sách quyền riêng tư",
		"aiToolsTos": "Điều khoản sử dụng công cụ AI",
		"support": "Hỗ trợ",
		"supportEmailBody": "Tôi liên hệ với bạn vì tôi cần được hỗ trợ về [  ]\n\n\n\nDưới đây là một số thông tin hữu ích để giúp giải quyết vấn đề nhanh hơn: \n\nTên người dùng liên kết với tài khoản (có trong phần cài đặt khi đăng nhập vào ứng dụng):\n{{username}}\n\nEmail liên kết với đơn hàng của tôi (có trong phần cài đặt khi đăng nhập vào ứng dụng):\n{{email}}\n\nMã đơn hàng (thường có trong email biên nhận được gửi sau khi mua hàng):\n\nCó khả năng tên hoặc email khác đã được sử dụng khi thực sự mua sản phẩm không? Nếu có, vui lòng cung cấp thông tin đó:\n\nHọ và tên:\n\nEmail:",
		"contactSupport": "Liên hệ bộ phận hỗ trợ",
		"signOut": "Đăng xuất",
		"signOutConfirmation": "Bạn có chắc chắn muốn đăng xuất không?",
		"deleteAccount": "Xóa tài khoản",
		"platform": "Nền tảng",
		"partnerships": "Đối tác",
		"validUntil": "Hết hạn vào {{date}}",
		"extendValidity": "Gia hạn quyền truy cập",
		"redeemPurchase": "Đổi giao dịch mua",
		"redeemPurchaseNoneFound": "Không có giao dịch mua nào để đổi",
		"redeemPurchaseCheckFailed": "Không thể kiểm tra giao dịch mua. Vui lòng thử lại.",
		"purchases": "Giao dịch mua",
		"frequentlyAskedQuestions": "Câu hỏi thường gặp",
		"deleteFeedbackForm": {
			"placeholder": "Phản hồi"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "Cần thêm dữ liệu",
		"proficiencyLevelPendingTooltip": "Trả lời thêm câu {{label}} để ước tính trình độ của bạn",
		"on": "bật",
		"gotIt": "Đã hiểu",
		"goBack": "Quay lại",
		"topic": "chủ đề",
		"itemCount_one": "{{count}} mục",
		"itemCount_other": "{{count}} mục",
		"examCount_one": "{{count}} bài thi",
		"examCount_other": "{{count}} bài thi",
		"questionCount_one": "{{count}} câu hỏi",
		"questionCount_other": "{{count}} câu hỏi",
		"item_one": "mục",
		"item_other": "mục",
		"and": "và",
		"this": "này",
		"of": "trên",
		"knowMore": "Tìm hiểu thêm",
		"proficiency": "trình độ",
		"didNotAnswer": "Các mục bạn chưa làm",
		"notAnswered": "Chưa trả lời",
		"attempted": "đã làm",
		"attempt": "lần làm",
		"activity": "hoạt động",
		"performance": "Kết quả",
		"estimatedProficiency": "Trình độ ước tính",
		"details": "chi tiết",
		"keepPracticing": "hãy tiếp tục luyện tập!",
		"leaveFeedback": "Gửi phản hồi",
		"copiedToClipboard": "Đã sao chép vào bộ nhớ tạm",
		"eg": "ví dụ:",
		"set": "bộ",
		"hint": "gợi ý",
		"itemType": "loại mục",
		"minute": "phút",
		"minutes": "{{count}} phút",
		"hour": "giờ",
		"hours": "{{count}} giờ",
		"continue": "Tiếp tục",
		"unlock": "Mở khóa",
		"cancel": "Hủy",
		"view": "Xem",
		"switch": "Chuyển",
		"update": "Cập nhật",
		"ok": "OK",
		"yes": "Có",
		"free": "Miễn phí",
		"answered": "Đã trả lời",
		"correct": "Đúng",
		"incorrect": "Sai",
		"marked": "Đã đánh dấu",
		"unmarked": "Chưa đánh dấu",
		"skipped": "Đã bỏ qua",
		"skill_one": "kỹ năng",
		"skill_other": "kỹ năng",
		"word_one": "từ",
		"word_other": "từ",
		"submitResponse": "Nộp câu trả lời",
		"viewDetails": "Xem chi tiết",
		"sec_one": "giây",
		"sec_other": "giây",
		"point_one": "điểm",
		"point_other": "điểm",
		"week": "Tuần",
		"month": "Tháng",
		"year": "Năm",
		"day": "Ngày",
		"selectTestDate": "Chọn ngày thi",
		"points": "Điểm",
		"viewAll": "Xem tất cả",
		"timeline": "Dòng thời gian",
		"save": "Lưu",
		"filters": {
			"selectAll": "Chọn tất cả",
			"deselectAll": "Bỏ chọn tất cả",
			"selectedCount": "Đã chọn {{count}}",
			"expandSection": "Mở rộng {{section}}",
			"collapseSection": "Thu gọn {{section}}"
		},
		"showMore": "Xem thêm",
		"showLess": "Ẩn bớt",
		"expandA11yLabel": "Mở rộng mô tả",
		"collapseA11yLabel": "Thu gọn mô tả",
		"done": "Xong",
		"clearAll": "Xóa tất cả",
		"clear": "Xóa",
		"datePicker": {
			"title": "Chọn ngày",
			"enterDateLabel": "Nhập ngày",
			"enterDateRangeLabel": "Nhập khoảng ngày",
			"dateLabel": "Ngày",
			"startDateLabel": "Ngày bắt đầu",
			"endDateLabel": "Ngày kết thúc",
			"dateRequiredError": "Vui lòng nhập ngày",
			"invalidDateFormatError": "Định dạng ngày không hợp lệ. Vui lòng dùng MM/DD/YYYY",
			"startAfterEndError": "Ngày bắt đầu không được sau ngày kết thúc",
			"endBeforeStartError": "Ngày kết thúc không được trước ngày bắt đầu",
			"minDateError": "Ngày phải là {{date}} hoặc sau đó",
			"maxDateError": "Ngày phải là {{date}} hoặc trước đó",
			"dateRangeError": "Ngày phải trong khoảng {{startDate}} đến {{endDate}}",
			"setDateCta": "Đặt ngày",
			"nextCta": "Tiếp theo",
			"setTimeCta": "Đặt giờ"
		}
	},
	"session": {
		"choicePercentageTooltip": "{{percentage}} người học đã chọn đáp án này.",
		"choiceCorrectA11yLabel": "Đáp án đúng",
		"choiceIncorrectA11yLabel": "Đáp án sai",
		"choiceNotSelectedA11yLabel": "Chưa chọn",
		"moreItemsAlertDialog": {
			"title": "Câu hỏi bổ sung",
			"cta": "Đã hiểu"
		},
		"results": {
			"followUps": {
				"title": "Nội dung tiếp theo"
			},
			"summary": {
				"sessionAnalysis": "Phân tích phiên học",
				"itemCount_one": "{{count}} câu hỏi",
				"itemCount_other": "{{count}} câu hỏi",
				"skilledItemCount_one": "{{count}} câu hỏi {{skills}}",
				"skilledItemCount_other": "{{count}} câu hỏi {{skills}}",
				"levelPhrase_one": "thuộc trình độ {{levels}}",
				"levelPhrase_other": "thuộc trình độ {{levels}}",
				"message": "<bold>Làm tốt lắm!</bold> Bạn vừa hoàn thành {{itemPhrase}} trong {{timeTaken}}.",
				"messageWithLevels": "<bold>Làm tốt lắm!</bold> Bạn vừa hoàn thành {{itemPhrase}} $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) trong {{timeTaken}}.",
				"proficiencyEstimateReady": "Trình độ {{skill}} ước tính của bạn là <bold>{{currentLevel}}</bold>. Giờ bạn đã sẵn sàng hướng tới <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateKeepPracticing": "Trình độ {{skill}} ước tính của bạn là <bold>{{currentLevel}}</bold>. Hãy tiếp tục luyện tập trước khi chuyển lên <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateHighest": "Trình độ {{skill}} ước tính của bạn là <bold>{{currentLevel}}</bold>. Thành tích xuất sắc!",
				"mixedLevel": "Hỗn hợp",
				"overallScore": "Điểm tổng",
				"stats": {
					"itemsAttempted_one": "Câu hỏi đã làm",
					"itemsAttempted_other": "Câu hỏi đã làm",
					"pointsEarned_one": "Điểm đạt được",
					"pointsEarned_other": "Điểm đạt được",
					"answeredCorrectly": "Trả lời đúng",
					"timeTaken": "Thời gian làm bài",
					"target": "Mục tiêu",
					"ofTotal": "trên {{total}}",
					"ofPointsTotal": "trên {{total}}",
					"skill": "Kỹ năng",
					"skills": "Kỹ năng",
					"questionType": "Dạng câu hỏi",
					"questionTypes": "Dạng câu hỏi",
					"proficiencyLevel": "Trình độ",
					"proficiencyLevels": "Các trình độ"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "Âm thanh bắt đầu sau {{seconds}} giây",
			"audioStartsInPlayOnce": "Âm thanh bắt đầu sau {{seconds}} giây và chỉ phát một lần",
			"videoStartsIn": "Video bắt đầu sau {{seconds}} giây",
			"videoStartsInPlayOnce": "Video bắt đầu sau {{seconds}} giây và chỉ phát một lần",
			"recordingIn": "Bắt đầu ghi âm sau {{seconds}} giây"
		},
		"timeOverrunBanner": {
			"message": "Đã hết giờ. Trong kỳ thi thật, mọi nội dung làm sau thời điểm này sẽ không được chấm điểm. Bạn vẫn có thể tiếp tục luyện tập."
		},
		"attributes": {
			"stimulus": "ngữ liệu"
		},
		"stimulusTypes": {
			"reading": "Đọc",
			"listening": "Nghe",
			"speaking": "Nói",
			"writing": "Viết",
			"image": "Hình ảnh"
		},
		"masteryLevels": {
			"belowBasic": "Dưới cơ bản",
			"basic": "Cơ bản",
			"belowLowIntermediate": "Dưới sơ trung cấp",
			"lowIntermediate": "Sơ trung cấp",
			"highIntermediate": "Cao trung cấp",
			"advanced": "Nâng cao",
			"proficiencySubtitle": "Trong bài thi {{trademark}}, trình độ này tương ứng với mức điểm **{{minScore}}-{{maxScore}}/30**",
			"infoSectionLabel": "Thông tin phần {{skill}}",
			"infoSectionText": {
				"Reading": "Phần Đọc của bài thi {{trademark}} đánh giá khả năng đọc và hiểu các tài liệu viết được sử dụng trong môi trường học thuật. Phần này gồm hai bài đọc, mỗi bài dài khoảng 700 từ, với 10 câu hỏi cho mỗi bài. Bạn sẽ cần khoảng 35 phút để hoàn thành phần Đọc.",
				"Listening": "Phần Nghe của bài thi {{trademark}} được thiết kế để đánh giá khả năng hiểu các cuộc hội thoại và bài giảng bằng tiếng Anh. Nội dung nghe bao gồm: hiểu ý cơ bản, hiểu thái độ và mức độ chắc chắn của người nói, cũng như kết nối thông tin. Bạn sẽ cần khoảng 36 phút để hoàn thành phần Nghe.",
				"Speaking": "Phần Nói của bài thi {{trademark}} đánh giá khả năng nói tiếng Anh hiệu quả trong môi trường học thuật. Bốn câu hỏi/nhiệm vụ mô phỏng các tình huống thực tế mà bạn có thể gặp trong và ngoài lớp học. Bạn sẽ cần khoảng 16 phút để hoàn thành phần Nói.",
				"Writing": "Phần Viết của bài thi {{trademark}} đánh giá khả năng viết bằng tiếng Anh trong môi trường học thuật và trình bày ý tưởng rõ ràng, mạch lạc. Bạn sẽ nhập câu trả lời bằng bàn phím máy tính và cần khoảng 29 phút để hoàn thành phần Viết."
			}
		},
		"itemTypes": {
			"MCSS": "Trắc nghiệm chọn một đáp án",
			"MCSSH": "Trắc nghiệm chọn một phần tô sáng",
			"MCMS": "Trắc nghiệm chọn nhiều đáp án",
			"MCMSH": "Trắc nghiệm chọn nhiều phần tô sáng",
			"INSERT_TEXT": "Chèn văn bản",
			"MATCH_MS": "Ghép nối chọn nhiều đáp án",
			"MCSSM": "Trắc nghiệm ghép nối chọn một đáp án",
			"MCMSM": "Trắc nghiệm ghép nối chọn nhiều đáp án",
			"MCGS": "Trắc nghiệm chọn đáp án điền vào chỗ trống",
			"MCOS": "Trắc nghiệm sắp xếp thứ tự",
			"LISTENING_REPLAY": "Nghe và nhắc lại",
			"AUDIO_INPUT": "Câu trả lời bằng âm thanh",
			"ACADEMIC_DISCUSSION_RESPONSE": "Phản hồi thảo luận học thuật",
			"INTEGRATED_WRITING_RESPONSE": "Phản hồi viết tích hợp"
		},
		"passageStem": {
			"itemOfTotal": "Câu {{current}} trên {{total}}",
			"questionOfTotal": "Câu hỏi {{current}} trên {{total}}",
			"stimulusCorrespondsToNextItems": "Ngữ liệu sau đây áp dụng cho {{total}} câu hỏi tiếp theo",
			"passage": "Bài đọc",
			"lecture": "Bài giảng",
			"professorsQuestion": "Câu hỏi của giảng viên",
			"listen": "Nghe",
			"openPassage": "Mở bài đọc",
			"backToItem": "Quay lại câu hỏi",
			"notYetInserted": "Chưa được chèn",
			"insertedAtPosition": "Đã chèn tại vị trí #{{position}}"
		},
		"hint": {
			"show": "Hiện gợi ý"
		},
		"navigation": {
			"next": "Tiếp theo",
			"exit": "Thoát",
			"saveAndExit": "Lưu và thoát",
			"previous": "Trước",
			"skip": "Bỏ qua",
			"finish": "Hoàn thành",
			"help": "Trợ giúp",
			"about": "Mẹo làm bài",
			"questionsButtonLabel": "Điều hướng câu hỏi",
			"questionsButtonTooltip": "Chuyển đến câu hỏi bất kỳ hoặc xem lại các câu đã đánh dấu",
			"questionsButtonActiveFiltersA11y": "Bộ lọc đang áp dụng: {{count}}",
			"recordingInProgressTooltip": "Bạn không thể rời khỏi câu hỏi này khi đang ghi âm",
			"questionNotReachedTooltip": "Bạn chưa đến câu hỏi này"
		},
		"questionTips": {
			"hideFutureLabel": "Không tự động hiện mẹo"
		},
		"toolbar": {
			"calculatorTooltip": "Mở máy tính",
			"highlightTooltip": "Chọn văn bản để tô sáng thông tin quan trọng, giúp dễ dàng xem lại",
			"markTooltip": "Đánh dấu câu hỏi này để xem lại trước khi nộp bài",
			"unmarkTooltip": "Nhấn để bỏ đánh dấu câu hỏi này"
		},
		"summary": {
			"viewFullInsights": "Xem toàn bộ thông tin chuyên sâu",
			"targetTooltip": "Mục tiêu kết quả của phiên học này."
		},
		"stats": {
			"skill": "Kỹ năng",
			"answered": "Đã trả lời",
			"speed": "Tốc độ",
			"duration": "Thời lượng",
			"duration_tooltip": "Thời lượng bản ghi âm câu trả lời của bạn: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "Mức độ tự tin",
			"pointsEarned": "Điểm",
			"word": "Từ",
			"words": "Từ",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "Bạn đã mất {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) để đọc và trả lời câu hỏi này",
			"skill_tooltip": "Kỹ năng được đánh giá trong câu hỏi này: {{skill}}",
			"answered_correct_tooltip": "Câu trả lời bạn đã nộp là chính xác",
			"answered_incorrect_tooltip": "Câu trả lời bạn đã nộp chưa chính xác",
			"skipped_tooltip": "Bạn chưa nộp câu trả lời cho câu hỏi này",
			"words_tooltip": "Số từ trong câu trả lời viết của bạn: {{count}}",
			"word_tooltip": "Số từ trong câu trả lời viết của bạn: {{count}}",
			"confidence_tooltip": "Mức độ tự tin của bạn khi nộp câu trả lời",
			"points_earned_tooltip_one": "Bạn đạt {{points}} điểm trên tổng số điểm tối đa {{maximumScore}} cho câu hỏi này",
			"points_earned_tooltip_other": "Bạn đạt {{points}} điểm trên tổng số điểm tối đa {{maximumScore}} cho câu hỏi này",
			"challengers_tooltip": "Số người học đã làm câu hỏi này trước bạn: {{count}}",
			"learning_mode_points_tooltip": "Điểm đạt được trong lần làm này: +{{xp}} XP",
			"pts_earned_tooltip": "Điểm đạt được trong lần làm này: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "Mở rộng bảng phân tích"
		},
		"explanation": {
			"title": "Giải thích",
			"feedback": "Phản hồi",
			"skippedFeedbackNotice": "Bạn đã bỏ qua câu hỏi này nên không có nhận xét cá nhân hóa nào được tạo."
		},
		"followUps": "Nội dung tiếp theo",
		"suggestCorrection": "Đề xuất chỉnh sửa",
		"answer": {
			"correct": "Chính xác",
			"incorrect": "Chưa chính xác",
			"skipped": "Đã bỏ qua"
		},
		"confidence": {
			"high": "Cao",
			"medium": "Trung bình",
			"low": "Thấp"
		},
		"endDialog": {
			"title": "Kết thúc phiên học sớm?",
			"confirmEndDiagnostic": "Bạn có chắc muốn kết thúc phiên học không? Toàn bộ tiến độ sẽ bị mất và bạn sẽ phải bắt đầu lại.",
			"confirmEnd": "Bạn vẫn còn {{num}} {{itemLabel}}. Bạn có thể hoàn thành ngay hoặc tiếp tục học để làm hết.",
			"confirmEndNoAnswer": "Bạn chưa trả lời câu hỏi nào. Bạn có chắc muốn hoàn thành ngay không?",
			"confirmEndNoAnswerPositive": "Tiếp tục học",
			"confirmEndNoAnswerNegative": "Hoàn thành ngay"
		},
		"permissionDialog": {
			"title": "Cần quyền truy cập micrô",
			"descriptionWeb": "Phần luyện nói cần dùng micrô của bạn. Trình duyệt đang chặn quyền truy cập cho trang này — hãy nhấn vào biểu tượng quyền bên cạnh địa chỉ web, cho phép sử dụng micrô rồi thử lại.",
			"descriptionMobile": "Phần luyện nói cần dùng micrô của bạn. Hãy cho phép truy cập micrô trong phần cài đặt thiết bị để tiếp tục.",
			"promptDescriptionWeb": "Phần luyện nói cần dùng micrô của bạn. Hãy yêu cầu quyền và chọn Cho phép khi trình duyệt hỏi.",
			"blockedDescriptionWeb": "Quyền truy cập micrô đang bị chặn cho trang này. Nhấn vào biểu tượng bên cạnh địa chỉ web, cho phép micrô rồi yêu cầu quyền lại.",
			"ok": "OK",
			"cancel": "Hủy",
			"openSettings": "Mở cài đặt",
			"requestPermission": "Yêu cầu quyền",
			"dismissAndExit": "Đóng và thoát",
			"learnMore": "Tìm hiểu thêm"
		},
		"audioPlaybackTestDialog": {
			"title": "Kiểm tra phát âm thanh",
			"description": "Ứng dụng {{appName}} có nhiều tính năng phát âm thanh, chẳng hạn như âm thanh trong ngữ liệu, câu hỏi kiểm tra và tính năng chuyển văn bản thành giọng nói. Để có trải nghiệm tốt nhất, vui lòng kiểm tra âm thanh bên dưới. Sau khi xác nhận âm thanh hoạt động, hãy tiếp tục.",
			"troubleshooting": {
				"title": "Khắc phục sự cố âm thanh",
				"volumeTitle": "Kiểm tra âm lượng thiết bị",
				"volumeDescriptionWeb": "Điều chỉnh âm lượng bằng các phím trên bàn phím hoặc phần cài đặt âm lượng hệ thống trong menu/thanh tác vụ",
				"volumeDescriptionMobile": "Sử dụng nút âm lượng trên thiết bị hoặc điều chỉnh trong phần cài đặt hệ thống",
				"outputTitle": "Kiểm tra thiết bị đầu ra âm thanh",
				"outputDescription": "Nếu sử dụng tai nghe, hãy đảm bảo tai nghe được kết nối đúng cách và được chọn làm thiết bị đầu ra đang hoạt động",
				"browserTitle": "Kiểm tra âm thanh của thẻ trình duyệt",
				"browserDescription": "Tìm biểu tượng loa bị tắt tiếng bên cạnh tiêu đề thẻ và bật tiếng nếu có."
			},
			"skipCheck": "Bỏ qua bước kiểm tra này vào lần sau",
			"workingButton": "Xác nhận âm thanh",
			"textToHear": "Bạn sẽ nghe thấy: {{text}}"
		},
		"overall": "Tổng thể",
		"subskills": {
			"content": {
				"title": "Nội dung"
			},
			"languageUse": {
				"title": "Sử dụng ngôn ngữ"
			},
			"organizationAndDevelopment": {
				"title": "Tổ chức và phát triển ý"
			},
			"topicDevelopment": {
				"title": "Phát triển chủ đề"
			},
			"delivery": {
				"title": "Cách trình bày"
			}
		},
		"finalizing": {
			"title": "Đang hoàn tất kết quả của bạn",
			"gradingProgress": "Đang chấm câu trả lời..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "Bài nói trong đó người học lặp lại câu vừa nghe một cách chính xác nhất có thể.",
			"Read Aloud": "Câu hỏi nói trong đó người học đọc to một đoạn văn để được đánh giá.",
			"Describe Image": "Bài nói trong đó người học mô tả chi tiết một hình ảnh.",
			"Write Essay": "Bài viết yêu cầu một bài luận có cấu trúc về chủ đề cho trước.",
			"Retell Lecture": "Bài nói trong đó người học tóm tắt bài giảng hoặc bài nói chuyện đã nghe.",
			"Summarize Group Discussion": "Bài nghe trong đó người học tóm tắt cuộc thảo luận có nhiều người nói.",
			"Answer Short Question": "Bài nói ngắn trong đó người học trả lời ngắn gọn một câu hỏi ngắn.",
			"Respond to a Situation": "Bài nói trong đó người học phản hồi phù hợp với tình huống được mô tả.",
			"Summarize Written Text": "Bài đọc trong đó người học tóm tắt một đoạn văn bằng lời của mình.",
			"Reorder Paragraph": "Bài đọc trong đó người học sắp xếp các đoạn văn bị xáo trộn theo đúng thứ tự.",
			"Fill in the Blanks (Dropdown)": "Bài đọc trong đó mỗi chỗ trống được điền bằng cách chọn từ danh sách thả xuống.",
			"Fill in the Blanks (Type In)": "Bài nghe trong đó người học gõ từ hoặc cụm từ ngắn còn thiếu.",
			"Fill in the Blanks (Drag and Drop)": "Bài đọc trong đó các từ còn thiếu được điền bằng cách kéo thả các lựa chọn vào chỗ trống.",
			"Multiple Choice, Single Answer": "Câu hỏi trắc nghiệm trong đó người học chọn một đáp án đúng.",
			"Multiple Choice, Single Answer (Reading)": "Câu hỏi trắc nghiệm đọc trong đó người học chọn một đáp án đúng.",
			"Multiple Choice, Single Answer (Listening)": "Câu hỏi trắc nghiệm nghe trong đó người học chọn một đáp án đúng.",
			"Multiple Choice, Multiple Answers": "Câu hỏi trong đó người học có thể chọn nhiều hơn một đáp án đúng.",
			"Multiple Choice, Multiple Answers (Reading)": "Câu hỏi đọc trong đó người học có thể chọn nhiều hơn một đáp án đúng.",
			"Multiple Choice, Multiple Answers (Listening)": "Câu hỏi nghe trong đó người học có thể chọn nhiều hơn một đáp án đúng.",
			"Summarize Spoken Text": "Bài nghe trong đó người học viết tóm tắt những gì đã nghe.",
			"Highlight Correct Summary": "Bài nghe trong đó người học chọn phần tóm tắt khớp nhất với đoạn âm thanh.",
			"Select Missing Word": "Bài nghe dạng điền khuyết trong đó người học chọn từ còn thiếu.",
			"Highlight Incorrect Words": "Bài nghe trong đó người học đánh dấu những từ trong bản ghi khác với đoạn âm thanh.",
			"Write from Dictation": "Bài nghe trong đó người học chép lại câu vừa nghe."
		}
	},
	"report": {
		"readFullInsights": "Đọc toàn bộ thông tin chuyên sâu",
		"productName": "{{examName}} {{type}}",
		"startedAt": "Bắt đầu lúc {{time}}",
		"itemTypesTitle": "Phân tích theo dạng câu hỏi",
		"itemTypesFilterAll": "Tất cả",
		"questionTypeCardTitle": "Phân tích dạng câu hỏi {{skill}}",
		"questionTypeCardSubtitle_one": "Dựa trên {{count}} dạng câu hỏi {{skill}} trong phiên này",
		"questionTypeCardSubtitle_other": "Dựa trên {{count}} dạng câu hỏi {{skill}} trong phiên này",
		"questionTypeCardAltSubtitle_one": "{{count}} dạng",
		"questionTypeCardAltSubtitle_other": "{{count}} dạng",
		"questionTypeRowSubtitle_zero": "Chưa làm câu hỏi nào",
		"questionTypeRowSubtitle_one": "{{count}} câu hỏi đã làm",
		"questionTypeRowSubtitle_other": "{{count}} câu hỏi đã làm",
		"itemTypeDetail": {
			"review_one": "Xem lại câu hỏi",
			"review_other": "Xem lại câu hỏi",
			"stats": {
				"answered_one": "Câu đã trả lời",
				"answered_other": "Câu đã trả lời",
				"avgTime": "Thời gian trung bình mỗi câu"
			}
		},
		"reviewAnswersDialog": {
			"title": "Xem lại câu trả lời",
			"sections": {
				"skills": "Kỹ năng",
				"questionTypes": "Dạng câu hỏi",
				"proficiency": "Mức độ thành thạo",
				"performance": "Kết quả"
			},
			"summaryNone": "Hãy chọn bộ lọc có câu hỏi để tiếp tục.",
			"summaryAll_one": "Xem lại tất cả {{count}} câu trả lời.",
			"summaryAll_other": "Xem lại tất cả {{count}} câu trả lời.",
			"summaryFiltered_one": "Xem lại {{count}} câu trả lời khớp với {{filters}}.",
			"summaryFiltered_other": "Xem lại {{count}} câu trả lời khớp với {{filters}}.",
			"reviewAnswers_one": "Xem lại {{count}} câu trả lời",
			"reviewAnswers_other": "Xem lại {{count}} câu trả lời",
			"more": "{{count}} mục khác"
		},
		"itemDetail": {
			"title": "Xem lại câu trả lời của tôi",
			"filterAll": "Tất cả",
			"filterCorrect": "Đúng",
			"filterIncorrect": "Sai",
			"filterMarked": "Đã đánh dấu",
			"emptyTitle": "Không có câu hỏi phù hợp",
			"emptyDescription": "Không có câu hỏi nào trong phiên học khớp với bộ lọc đã chọn ({{filter}}). Hãy điều chỉnh hoặc xóa bộ lọc để xem thêm kết quả.",
			"emptyCta": "Xóa bộ lọc"
		},
		"answerCardTitle": "Xem lại câu hỏi",
		"answerCardSubtitle_one": "Dựa trên {{count}} câu hỏi",
		"answerCardSubtitle_other": "Dựa trên {{count}} câu hỏi",
		"skillsBreakdown": {
			"title": "Phân tích kỹ năng",
			"subtitle_one": "Dựa trên {{count}} câu hỏi",
			"subtitle_other": "Dựa trên {{count}} câu hỏi"
		},
		"studyPack": "Gói học tập",
		"practiceTestCompleted": "Đã hoàn thành bài thi thử",
		"studySessionCompleted": "Đã hoàn thành phiên học",
		"diagnosticSessionCompleted": "Đã hoàn thành bài đánh giá chẩn đoán",
		"timeElapsed": "Thời gian đã dùng",
		"stats": {
			"answered": "ĐÃ TRẢ LỜI",
			"time elapsed": "THỜI GIAN ĐÃ DÙNG",
			"avg speed": "TỐC ĐỘ TRUNG BÌNH",
			"hints used": "GỢI Ý ĐÃ DÙNG"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "Xuất sắc—hãy tiếp tục vươn tới thành tích cao hơn!",
				"highIntermediate": "Bạn đang làm rất tốt—hãy tiếp tục phát huy thế mạnh!",
				"lowIntermediate": "Bạn đang tiến bộ đều đặn—hãy tiếp tục nhé!",
				"basic": "Hãy tiếp tục luyện tập để nâng cao năng lực!"
			},
			"infoText": "Bạn đã hoàn thành **{{numActivities}} {{activityLabel}}** để luyện tập {{skillsText}} {{skills}}. {{skillDetails}}. Nhìn chung, bạn đạt **{{numPointsEarned}} trên {{numTotalPoints}} điểm**, cho thấy mức độ thành thạo **{{compositeLevel}}** đối với {{thisText}} {{skills}}. {{compositeFeedback}}",
			"infoText.singleSkill": "Bạn đã hoàn thành **{{itemCount}} {{itemLabel}}** tập trung vào kỹ năng **{{skill_1}}**. Bạn đạt **{{skill_1_score}} trên {{skill_1_total}}**, cho thấy mức độ thành thạo **{{proficiency}}**. {{compositeFeedback}}",
			"infoText.multiSkill": "Bạn đã hoàn thành **{{itemCount}} {{itemLabel}}**, luyện tập các kỹ năng **{{skills_text}}**. {{skill_details}} Nhìn chung, bạn đạt **{{overall_score}} trên {{overall_total}} điểm**, cho thấy mức độ thành thạo **{{overall_proficiency}}** ở các kỹ năng này. {{compositeFeedback}}",
			"skillDetails": "Ở kỹ năng **{{skill}}**, bạn đạt **{{score}} trên {{total}}**, cho thấy mức độ thành thạo **{{proficiency}}**."
		},
		"actions": {
			"goToHome": "Về trang chủ",
			"studyMore": "Học thêm",
			"studyFree": "Học miễn phí {{tagTypes}}",
			"reviewAnswers": "Xem lại câu trả lời"
		},
		"nextAction": {
			"title": "Đề xuất: luyện tập {{focus}}",
			"dialog": {
				"title": "Buổi học được đề xuất",
				"subtitle": "Tập trung vào những phần còn yếu"
			},
			"fallback": {
				"title": "Tiếp tục luyện tập",
				"description": "Tạo buổi học tập trung vào những phần bạn muốn luyện tiếp theo."
			}
		},
		"premium": {
			"upgradeCta": "Nâng cấp lên gói Premium"
		},
		"disclaimer": {
			"title": "Tuyên bố miễn trừ trách nhiệm",
			"summativeBody": "Điểm thi thử chỉ là ước tính và không đảm bảo kết quả tương tự trong kỳ thi {{examName}} chính thức. Điểm thực tế có thể khác tùy vào điều kiện thi và cách chấm điểm chính thức."
		},
		"performance": {
			"title": "Kết quả",
			"subtitle": "Dựa trên {{count}} câu hỏi",
			"correct": "Đúng",
			"correctItems": "{{count}} câu hỏi",
			"incorrect": "Sai",
			"incorrectItems": "{{count}} câu hỏi"
		},
		"mastery": {
			"performanceTitle": "Kết quả",
			"sessionMasteryTitle": "Mức độ thành thạo ước tính",
			"subtitle_assessment": "Dựa trên toàn bộ {{count}} {{item}} của bài đánh giá này",
			"subtitle_session": "Dựa trên toàn bộ {{count}} {{item}} của phiên học này"
		},
		"sessionAnalysis": {
			"title": "Phân tích phiên học",
			"subtitle": "Phân tích và đề xuất dành riêng cho bạn",
			"viewFullAnalysis": "Xem phân tích",
			"feedbackDialog": {
				"body": "Chúng tôi cập nhật gần như mỗi ngày và luôn nỗ lực cải thiện. Bạn có thể để lại phản hồi không?",
				"placeholder": "Nhập phản hồi tại đây",
				"cta": "Gửi phản hồi",
				"successMessage": "Đã gửi phản hồi. Cảm ơn bạn!",
				"feedbackLimitError": "Phản hồi phải có ít nhất 10 ký tự"
			},
			"menuActions": {
				"copy": "Sao chép",
				"altCopy": "Sao chép nội dung tóm tắt",
				"altPositiveFeedback": "Nội dung này hữu ích",
				"positiveFeedback": "Phản hồi tốt",
				"negativeFeedback": "Phản hồi chưa tốt",
				"reportIssue": "Báo cáo",
				"altReportIssue": "Báo cáo phản hồi này",
				"emailSummary": "Gửi nội dung tóm tắt qua email",
				"emailAlreadySent": "Email đã được gửi",
				"copiedAnalysis": "Đã sao chép phân tích vào bảng nhớ tạm",
				"emailSent": "Đã gửi email đến {{email}}, Nếu bạn không nhận được email, hãy kiểm tra thư mục thư rác, spam và thư đã xóa gần đây",
				"emailFailed": "Không thể gửi email đến {{email}}",
				"emailInstructionMessage": "Nếu bạn không nhận được email, hãy kiểm tra thư mục thư rác, spam và thư đã xóa gần đây, hoặc liên hệ với quản trị viên CNTT"
			}
		}
	},
	"feedback": {
		"successMessage": "Đã gửi phản hồi. Cảm ơn bạn!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "Bạn thích điều gì? Điều gì cần cải thiện? Chúng tôi cải thiện nền tảng mỗi ngày và đội ngũ của chúng tôi đọc mọi phản hồi. Cảm ơn bạn!",
			"title": "Chia sẻ phản hồi",
			"body": "Bạn thích điều gì? Điều gì cần cải thiện? Chúng tôi cải thiện nền tảng mỗi ngày và đội ngũ của chúng tôi đọc mọi phản hồi. **Cảm ơn bạn!**",
			"positiveBody": "Rất vui vì nội dung này hữu ích! Hãy cho chúng tôi biết **bạn thích điều gì.**",
			"negativeBody": "Hãy giúp chúng tôi hiểu vấn đề để có thể **cải thiện phản hồi.**",
			"placeholder": "Nhập phản hồi",
			"cta": "Gửi phản hồi"
		},
		"report": {
			"title": "Gửi báo cáo",
			"body": "Hãy giúp chúng tôi hiểu phản hồi này có vấn đề gì",
			"cta": "Gửi báo cáo"
		},
		"suggestCorrection": {
			"title": "Đề xuất chỉnh sửa",
			"body": "Hãy giúp chúng tôi nâng cao độ chính xác của nội dung bằng cách **báo cáo mọi lỗi.**",
			"cta": "Gửi"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "Không chính xác",
					"description": "Phản hồi có thông tin không chính xác"
				},
				"notHelpful": {
					"title": "Không hữu ích",
					"description": "Phản hồi không giải đáp câu hỏi của tôi"
				},
				"incomplete": {
					"title": "Chưa đầy đủ",
					"description": "Phản hồi thiếu các chi tiết quan trọng"
				},
				"hardToUnderstand": {
					"title": "Khó hiểu",
					"description": "Phản hồi gây nhầm lẫn hoặc không rõ ràng"
				},
				"other": {
					"title": "Khác",
					"description": "Lý do khác"
				}
			},
			"report": {
				"misinformation": {
					"title": "Thông tin sai lệch",
					"description": "Phản hồi có thông tin sai hoặc gây hiểu lầm"
				},
				"harmfulContent": {
					"title": "Nội dung có hại hoặc xúc phạm",
					"description": "Ngôn từ thù ghét, quấy rối hoặc không phù hợp"
				},
				"violatesPolicies": {
					"title": "Vi phạm chính sách",
					"description": "Nội dung rác, tự quảng bá hoặc bất hợp pháp"
				},
				"other": {
					"title": "Khác",
					"description": "Hãy mô tả vấn đề bằng lời của bạn"
				}
			}
		},
		"faqs": {
			"title": "Câu hỏi thường gặp",
			"body": "Dưới đây là một số câu hỏi thường gặp nhất về ứng dụng. Nếu bạn có câu hỏi khác, vui lòng liên hệ với chúng tôi qua support@memorang.ai"
		},
		"delete": {
			"title": "Xóa tài khoản",
			"body": "Rất tiếc khi bạn rời đi. Chúc bạn đạt nhiều thành công trên hành trình học tập và sự nghiệp!",
			"options": "Quá đắt|Tôi đã thi xong|Tôi không thích nội dung|Thiếu tính năng/chức năng|Khác",
			"confirmdelete": {
				"title": "Xác nhận xóa tài khoản",
				"cta": "Xóa",
				"errorMessage": "Rất tiếc, email đó không khớp với tài khoản này. Vui lòng thử lại",
				"successMessage": "Đã xóa tài khoản!",
				"validEmail": "Vui lòng nhập địa chỉ email hợp lệ"
			}
		}
	},
	"recorder": {
		"tapToRecord": "Nhấn để ghi âm câu trả lời",
		"responseAudioUnavailable": "Không thể phát lại âm thanh câu trả lời",
		"recording": "Đang ghi âm",
		"recordingCompleted": "Đã ghi âm xong",
		"getReady": "Hãy sẵn sàng",
		"timeIsUp": "Đã hết giờ. Câu trả lời của bạn chưa được ghi âm.",
		"alert": {
			"title": "Đã đạt thời lượng tối đa",
			"body": "Bản ghi âm đã dừng vì đạt thời lượng tối đa là {{maxDuration}} giây."
		},
		"uiElementPressed": "Đã dừng ghi âm - nội dung gợi ý được mở khi đang ghi âm."
	},
	"writing": {
		"placeholder": "Viết câu trả lời của bạn tại đây...",
		"wordCount": "{{count}} {{word}}",
		"title": "Câu trả lời của bạn",
		"submit": "Nộp",
		"helper": {
			"range": "Viết từ {{min}}–{{max}} từ để nộp câu trả lời",
			"min": "Viết ít nhất {{min}} từ để nộp câu trả lời",
			"max": "Rút gọn câu trả lời còn tối đa {{max}} từ"
		}
	},
	"navbar": {
		"home": "Trang chủ",
		"progress": "Tiến độ",
		"insights": "Thông tin chi tiết",
		"leaderboard": "Bảng xếp hạng",
		"store": "Cửa hàng",
		"more": "Thêm",
		"redeem": "Đổi mã",
		"study-pack": "Study-Pack",
		"podcasts": "Podcasts",
		"modules": "Học phần",
		"account": "Cài đặt tài khoản",
		"accountTab": "Tài khoản",
		"privacy": "Quyền riêng tư",
		"terms": "Điều khoản",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "Đã nhập đúng mã nhưng vẫn gặp sự cố? **Liên hệ hỗ trợ** và nhớ đính kèm mã truy cập cùng thông tin mua hàng của bạn",
		"olxDialog": {
			"unlockedTitle": "Đã mở khóa quyền truy cập",
			"expiredTitle": "Quyền truy cập đã hết hạn",
			"testInfo": "**Kỳ thi:** {{examName}} | **Bài kiểm tra:** {{bundleName}}",
			"upcomingBody_one": "Quyền truy cập của bạn vào bài kiểm tra OLX đã được mở khóa!\n\nBạn có thể bắt đầu phiên làm bài trong **{{count}} ngày** nữa. Vui lòng quay lại sau để bắt đầu phiên làm bài từ tab Bài kiểm tra thử.",
			"upcomingBody_other": "Quyền truy cập của bạn vào bài kiểm tra OLX đã được mở khóa!\n\nBạn có thể bắt đầu phiên làm bài trong **{{count}} ngày** nữa. Vui lòng quay lại sau để bắt đầu phiên làm bài từ tab Bài kiểm tra thử.",
			"activeBody": "Quyền truy cập của bạn vào bài kiểm tra OLX hiện đã hoạt động!\n\nBạn có thể bắt đầu phiên làm bài bất kỳ lúc nào trước **{{date}}**.\n\nBạn có muốn bắt đầu phiên làm bài ngay bây giờ hay để sau?",
			"expiredBody": "Quyền truy cập của bạn vào bài kiểm tra OLX đã hết hạn vào **{{date}}**.\n\nVui lòng liên hệ giáo viên hoặc quản trị viên trường học của bạn để được hỗ trợ thêm.",
			"startNowCta": "Bắt đầu ngay",
			"startLaterCta": "Bắt đầu sau"
		},
		"unexpectedError": "Đã xảy ra lỗi không mong muốn."
	},
	"redeemCode": {
		"titleRedeem": "Đổi mã truy cập",
		"titleGranted": "Đã cấp quyền truy cập",
		"formTitle": "Nhập mã truy cập của bạn",
		"accessCodeHint": "Nếu có mã truy cập, vui lòng nhập mã tại đây, bao gồm cả dấu gạch nối.",
		"submit": "Gửi",
		"access": "Truy cập tại đây",
		"helpFindCode": "Bạn cần trợ giúp tìm mã truy cập?",
		"troubleRedeeming": "Bạn gặp khó khăn khi đổi mã? Hãy hỏi Assistant!",
		"skipStep": "Bỏ qua bước này"
	},
	"autoRedeem": {
		"redeem": "Đổi",
		"redeeming": "Đang đổi...",
		"continue": "Tiếp tục",
		"unredeemedPrompt_one": "Có **{{count}} gói đăng ký** liên kết với địa chỉ email **{{email}}** chưa được đổi. Bạn có muốn thêm gói này vào tài khoản không?",
		"unredeemedPrompt_other": "Có **{{count}} gói đăng ký** liên kết với địa chỉ email **{{email}}** chưa được đổi. Bạn có muốn thêm các gói này vào tài khoản không?",
		"successMessage_one": "Chúc mừng! **Sản phẩm** bên dưới đã được mở khóa trong tài khoản của bạn. Sau khi nhấn tiếp tục, nội dung ứng dụng sẽ thay đổi theo kỳ thi: **{{examName}}**. Bạn có thể thay đổi bất cứ lúc nào trong cài đặt tài khoản nếu muốn học cho kỳ thi khác hoặc mua gói đăng ký khác.",
		"successMessage_other": "Chúc mừng! **{{count}} sản phẩm** bên dưới đã được mở khóa trong tài khoản của bạn. Sau khi nhấn tiếp tục, nội dung ứng dụng sẽ thay đổi theo kỳ thi: **{{examName}}**. Bạn có thể thay đổi bất cứ lúc nào trong cài đặt tài khoản nếu muốn học cho kỳ thi khác hoặc mua gói đăng ký khác."
	},
	"olxEligibility": {
		"goToPracticeTests": "Đi đến bài thi thử"
	},
	"moreChallenges": {
		"challenges": "Thử thách",
		"challengesCount": "{{value}} thử thách"
	},
	"tts": {
		"tooltip": "Nghe"
	},
	"commandBar": {
		"placeholder": "Tìm kiếm...",
		"input": {
			"placeholder": "Nhập lệnh hoặc tìm kiếm"
		},
		"sections": {
			"quickActions": "Thao tác nhanh"
		},
		"actions": {
			"changeExam": "Đổi kỳ thi",
			"switchToDarkMode": "Chuyển sang giao diện tối",
			"switchToLightMode": "Chuyển sang giao diện sáng",
			"setExamDate": "Đặt ngày thi"
		}
	},
	"filterView": {
		"placeholder": "Tìm kiếm kỳ thi..."
	},
	"transcript": {
		"show": "Hiện bản chép lời",
		"hide": "Ẩn bản chép lời"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "Logo ứng dụng",
			"testNameLabel": "Tên bài thi",
			"sectionLabel": "Phần",
			"back": "Quay lại",
			"pause": "Tạm dừng",
			"menuLabel": "Tùy chọn khác"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "Tiến độ bài thi",
			"of": "trên",
			"pauseSession": "Tạm dừng phiên",
			"timerTooltip": {
				"item": "Thời gian còn lại cho câu hỏi này",
				"section": "Thời gian còn lại trong phần này",
				"test": "Thời gian còn lại trong bài thi này"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "Tiếp theo"
		},
		"progressBar": {
			"timeLeftLabel": "Thời gian còn lại cho câu hỏi này",
			"timeLeftForUnit": "Thời gian còn lại cho phần này",
			"questionOf": "Câu {{current}} trên {{total}}",
			"questionProgress": "<b>{{current}}</b> trên {{total}}",
			"timesUp": "Đã hết giờ",
			"statusTooltips": {
				"answered": "Đã trả lời",
				"inProgress": "Đang làm",
				"skipped": "Đã bỏ qua",
				"notSeen": "Chưa xem"
			}
		},
		"timeRemainingDialog": {
			"title": "Bạn vẫn còn thời gian",
			"body": "Phần này vẫn còn thời gian. Bạn có muốn xem lại câu trả lời trước khi nộp không?",
			"reviewCta": "Xem lại câu trả lời"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "Nguồn",
				"answerTitle": "Câu trả lời của bạn",
				"remainingBadge": "Còn {{count}}",
				"placedBadge": "Đã đặt {{count}}",
				"pointsBadge": "{{earned}}/{{max}} điểm",
				"emptyHint": "Kéo các đoạn văn từ bảng bên trái vào đây"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "Thông tin hỗ trợ",
			"emailLabel": "Email",
			"subjectLabel": "Chủ đề",
			"messageBodyLabel": "Nội dung tin nhắn",
			"appDetailsLabel": "Thông tin ứng dụng",
			"appNameLabel": "Tên",
			"versionLabel": "Phiên bản",
			"platformLabel": "Nền tảng"
		},
		"chat": {
			"assistantTitle": "Trợ lý hỗ trợ {{tenantName}}",
			"fallbackTitle": "Trò chuyện",
			"betaWarning": "Trợ lý AI này đang trong giai đoạn **Beta**—các phản hồi đôi khi có thể không chính xác hoặc chưa đầy đủ.",
			"greeting": "Xin chào 👋 Bạn đang gặp khó khăn khi truy cập một sản phẩm phải không? Tôi ở đây để giúp bạn! Trước tiên, hãy xác định vấn đề. Điều nào sau đây mô tả đúng nhất tình huống của bạn?\n\n1. Tôi có mã truy cập, nhưng nó dường như không hoạt động.\n2. Tôi đã mua hàng, nhưng không tìm thấy mã truy cập của mình.\n3. Lẽ ra tôi phải được cấp quyền truy cập thông qua trường học, nhưng không tìm thấy mã truy cập của mình.\n4. Trước đây tôi có quyền truy cập vào một sản phẩm, nhưng hiện tại tôi không thể truy cập được nữa.\n\nVui lòng nhập số tương ứng với vấn đề của bạn.",
			"input": {
				"label": "Nhập tin nhắn...",
				"sendLabel": "Gửi"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 Đổi thành công",
			"previouslyRedeemedTitle": "🚀 Đã đổi trước đó",
			"subtitle": "Truy cập nội dung của bạn tại đây",
			"expires": "Hết hạn: {{date}}",
			"openCta": "Mở"
		},
		"purchases": {
			"title": "🎉 Đã tìm thấy mã truy cập",
			"subtitle": "Đổi để truy cập nội dung của bạn",
			"accessCodesLabel_one": "Mã truy cập",
			"accessCodesLabel_other": "Mã truy cập",
			"moreCodes_one": "(+ {{count}} mã nữa)",
			"moreCodes_other": "(+ {{count}} mã nữa)",
			"featuresLabel": "Tính năng",
			"redeemCta": "Đổi"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "Đã có phiên bản mới, nhấp vào làm mới để cập nhật.",
			"refreshCta": "Làm mới",
			"refreshA11yLabel": "Làm mới để cập nhật ứng dụng",
			"dismissTooltip": "Bỏ qua",
			"dismissA11yLabel": "Bỏ qua thông báo cập nhật"
		}
	},
	"cme": {
		"type": "Loại CME",
		"chooseExportMethod": "Chọn phương pháp xuất",
		"selectDateRange": "Chọn phạm vi ngày",
		"from": "Từ",
		"to": "Đến",
		"sendPdfTo": "Gửi PDF tới {{email}}",
		"downloadCertificate": "Tải xuống Chứng chỉ dưới dạng PDF",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "Tín chỉ CME Đã Kiếm",
		"confirmYourName": "Xác nhận tên của bạn",
		"certificateNameNotice": "Tên này sẽ được in trên Chứng chỉ CME của bạn.",
		"firstName": "Tên",
		"lastName": "Họ",
		"firstNamePlaceholder": "Nhập tên của bạn",
		"lastNamePlaceholder": "Nhập họ của bạn",
		"confirm": "Xác nhận",
		"creditsEarnedTitle": "CME Đã Kiếm",
		"creditRatioCaption": "12 Thử thách = 1 Tín chỉ CME",
		"earned": "Đã kiếm",
		"available": "Có sẵn",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "Xuất Chứng chỉ CME",
		"exportDisabledCaption": "Bạn cần phải kiếm được ít nhất 1 tín chỉ CME để xuất chứng chỉ của mình",
		"viewDisclaimer": "Xem Tuyên bố từ chối trách nhiệm CME"
	},
	"podcast": {
		"detail": {
			"descriptionHeading": "Mô tả",
			"tagsHeading": "Thẻ",
			"citationsHeading": "Trích dẫn",
			"playing": "Đang phát"
		},
		"a11y": {
			"artwork": "Ảnh bìa của {{title}}",
			"playEpisode": "Phát tập, {{duration}}",
			"pauseEpisode": "Tạm dừng tập",
			"play": "Phát",
			"pause": "Tạm dừng",
			"addToQueue": "Thêm vào hàng đợi",
			"removeFromQueue": "Xóa khỏi hàng đợi",
			"addBookmark": "Đánh dấu",
			"removeBookmark": "Bỏ đánh dấu",
			"seekBar": "Thanh tua",
			"skipPrevious": "Về bản trước",
			"skipNext": "Sang bản tiếp theo",
			"rewind": "Tua lùi {{seconds}} giây",
			"fastForward": "Tua tới {{seconds}} giây",
			"playbackSpeed": "Tốc độ phát {{speed}}x"
		}
	}
}
